export const formatSnapshotDateTime = (
  isoDateTime: string,
  timeZone?: string,
): string =>
  new Date(isoDateTime).toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone,
  });
